/**
 * #show_toast.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../../typeRegistry.js";
import { Toast } from "../../toast/toast.js";
function createBaseShowToastEffect() {
    return { toast: undefined };
}
export const ShowToastEffect = {
    $type: "devvit.ui.effect_types.v1alpha.ShowToastEffect",
    encode(message, writer = _m0.Writer.create()) {
        if (message.toast !== undefined) {
            Toast.encode(message.toast, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseShowToastEffect();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.toast = Toast.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { toast: isSet(object.toast) ? Toast.fromJSON(object.toast) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.toast !== undefined) {
            obj.toast = Toast.toJSON(message.toast);
        }
        return obj;
    },
    create(base) {
        return ShowToastEffect.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseShowToastEffect();
        message.toast = (object.toast !== undefined && object.toast !== null) ? Toast.fromPartial(object.toast) : undefined;
        return message;
    },
};
messageTypeRegistry.set(ShowToastEffect.$type, ShowToastEffect);
function createBaseToastActionEvent() {
    return {};
}
export const ToastActionEvent = {
    $type: "devvit.ui.effect_types.v1alpha.ToastActionEvent",
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseToastActionEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return ToastActionEvent.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseToastActionEvent();
        return message;
    },
};
messageTypeRegistry.set(ToastActionEvent.$type, ToastActionEvent);
function isSet(value) {
    return value !== null && value !== undefined;
}
